import { FormGroup } from "@blueprintjs/core";
import { CustomProps } from "../../types/fieldTypes";
import { FormFieldErrorContainer } from "../FieldError/FormFieldErrorContainer";
import { CoreFieldProps } from "../../types/fieldTypes";

export interface CustomFieldProps<TModel, TFieldProps> extends CustomProps {
  type: "Custom";
  form: TModel;
  renderer: CustomRendererBuilder<TModel, TFieldProps>;
}

export type CustomRendererBuilder<TModel, TFieldProps> = (
  form: TModel,
  rendererProps: TFieldProps
) => React.ReactNode;

const CustomFieldComponent = <TModel, TFieldProps extends CoreFieldProps>(
  props: CustomFieldProps<TModel, TFieldProps> & TFieldProps
) => {
  return (
    <FormGroup className="base-field">
      {props.renderer(props.form, props as unknown as TFieldProps)}
      {props.errorMessages && (
        <FormFieldErrorContainer errorMessages={props.errorMessages} />
      )}
    </FormGroup>
  );
};

export const CustomField = CustomFieldComponent;
export default CustomField;
